

export function normalizePhone(dialCode, phonenumber) {
  const phone = phonenumber && phonenumber[0] === '0' ? phonenumber?.substring(1) : phonenumber;
  return dialCode + phone;
}
